import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWind, faCheckCircle, faLeaf, faArrowRight, faTrophy, faCog, faStar, faAward, faMedal } from '@fortawesome/free-solid-svg-icons';
import SEO from './SEO';

const WindEnergy = () => {
  return (
    <div className="services">
      <SEO
        title="Wind Energy Systems | CoreNova Renewable Energy"
        description="Onshore and offshore wind solutions: design, installation, and monitoring for reliable generation."
        canonical="https://corenovarenewable.com/services/wind"
        keywords="wind energy, wind turbine, onshore wind, offshore wind, wind farm"
      />

      <section className="relative bg-gradient-to-r from-primary-green to-secondary-blue text-white py-20 lg:py-32 text-center overflow-hidden">
        <div className="absolute inset-0">
          <img src="/images/service hero.png" alt="Wind Services" className="w-full h-full object-cover opacity-60" />
          <div className="absolute inset-0 bg-gradient-to-r from-primary-green/40 to-secondary-blue/40"></div>
        </div>
        <div className="container relative z-10">
          <h1 className="text-4xl md:text-6xl font-bold">Wind Energy Systems</h1>
          <p className="text-xl md:text-2xl opacity-90">High-efficiency wind turbines for sustainable power</p>
        </div>
      </section>

<section className="section bg-gray-50">
  <div className="container max-w-6xl">
    <div className="text-center mb-16">
      <div className="w-20 h-20 bg-gradient-to-r from-secondary-blue to-secondary-blue-dark rounded-2xl flex items-center justify-center mx-auto mb-6">
        <FontAwesomeIcon icon={faWind} className="text-3xl text-white" />
      </div>
      <h2 className="text-3xl md:text-4xl font-bold text-dark mb-4">
        Wind Energy Solutions
      </h2>
      <p className="text-xl text-gray-600 max-w-3xl mx-auto">
        Harnessing the power of wind for a sustainable energy future
      </p>
    </div>

    <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
      <div className="space-y-6">
        <div className="bg-white rounded-2xl p-6 border border-gray-200">
          <p className="text-gray-700 leading-relaxed">
            As demand for energy increases globally, all types of energy will be needed to power 
            the world. Wind energy will be a critical part of the solution. One of the oldest sources of 
            Renewable Energy service, Wind Energy has been utilized by humans for centuries.
          </p>
        </div>
        
        <div className="bg-white rounded-2xl p-6 border border-gray-200">
          <p className="text-gray-700 leading-relaxed">
            A renewable and clean source, it is possible to harness without wasting natural 
            resources or producing toxic emissions. India has been one of the early adopters of Wind Energy and has been growing at 
            tremendous rates ever since. The Wind Energy industry has emerged as one of the 
            most rapidly expanding power generating sources. India is geographically well placed to 
            harness wind energy, from vast stretches of coastline to extensive plains.
          </p>
        </div>

        <div className="bg-white rounded-2xl p-6 border border-gray-200">
          <p className="text-gray-700 leading-relaxed">
            Building on these positive attributes, <a href="/home">Corenova Renewable Energies</a> has established a 
            solid portfolio of end-to-end skills. These include all phases of wind project development, namely site selection, project 
            building, and operation. Through these strengths, Corenova Renewable Energies is determined to provide 
            world-class <a href="/services/windadd">Wind Energy projects</a> that are of the highest quality, highest efficiency and 
            highest reliability.
          </p>
        </div>
      </div>
      
      <div className="relative">
        <div className="relative rounded-2xl overflow-hidden shadow-xl">
          <img 
            src="/images/wind 2.jpg" 
            alt="Wind Energy in India - Corenova Renewable Energy" 
            className="w-full h-96 object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
        </div>
        
        
      </div>
    </div>

    {/* Three Key Points with Icons */}
    <div className="grid md:grid-cols-3 gap-8 mb-16">
      <div className="bg-white rounded-2xl p-8 border border-gray-200 text-center hover:shadow-lg transition-shadow duration-300">
        <div className="w-16 h-16 bg-gradient-to-r from-primary-green to-primary-green-light rounded-2xl flex items-center justify-center mx-auto mb-6">
          <FontAwesomeIcon icon={faStar} className="text-2xl text-white" />
        </div>
        <h3 className="text-xl font-bold text-dark mb-4">High quality scale</h3>
        <p className="text-gray-700">
          By building workhorse products with strategic supplier partnerships.
        </p>
      </div>
      
      <div className="bg-white rounded-2xl p-8 border border-gray-200 text-center hover:shadow-lg transition-shadow duration-300">
        <div className="w-16 h-16 bg-gradient-to-r from-secondary-blue to-secondary-blue-dark rounded-2xl flex items-center justify-center mx-auto mb-6">
          <FontAwesomeIcon icon={faCog} className="text-2xl text-white" />
        </div>
        <h3 className="text-xl font-bold text-dark mb-4">Technology and customer value</h3>
        <p className="text-gray-700">
          Decarbonizing the globe through deep customer relationships and wind farm energy production leadership.
        </p>
      </div>
      
      <div className="bg-white rounded-2xl p-8 border border-gray-200 text-center hover:shadow-lg transition-shadow duration-300">
        <div className="w-16 h-16 bg-gradient-to-r from-primary-green to-secondary-blue rounded-2xl flex items-center justify-center mx-auto mb-6">
          <FontAwesomeIcon icon={faTrophy} className="text-2xl text-white" />
        </div>
        <h3 className="text-xl font-bold text-dark mb-4">Operational excellence</h3>
        <p className="text-gray-700">
          By achieving the world's best running fleet at a scale 10x of today's installed base.
        </p>
      </div>
    </div>

  

    {/* CTA Section */}
    <div className="text-center">
      <div className="bg-gradient-to-r from-secondary-blue to-secondary-blue-dark rounded-2xl p-12 text-white">
        <h3 className="text-3xl font-bold mb-6">Explore Wind Energy Solutions</h3>
        <p className="text-xl mb-8 opacity-90 max-w-3xl mx-auto">
          Partner with us for world-class wind energy projects with highest quality and reliability
        </p>
        <a 
          href="/contact" 
          className="btn bg-white text-secondary-blue hover:bg-gray-100 px-10 py-4 text-lg font-semibold inline-flex items-center justify-center gap-3"
        >
          Learn More About Wind Energy
          <FontAwesomeIcon icon={faArrowRight} className="text-lg" />
        </a>
      </div>
    </div>
  </div>
</section>
<section className="section bg-white">
  <div className="container max-w-6xl">
    <div className="text-center mb-16">
      <h2 className="text-3xl md:text-4xl font-bold text-dark mb-4">
        Wind Energy Solution in Odisha
      </h2>
    </div>

    <div className="grid lg:grid-cols-2 gap-12 items-center">
      <div>
        <div className="bg-white rounded-2xl p-6 mb-8 border border-gray-200">
          <p className="text-gray-700 leading-relaxed text-lg">
            With growing adoption of renewable energy in India, cities such as Bhubaneswar are becoming 
            major centers for sustainable growth. Companies and organizations in the region are increasingly 
            seeking <a href="/services/wind">wind power solutions in Odisha</a> to lower operational expenses, reduce carbon footprint, 
            and provide long-term energy security.
          </p>
        </div>
        
        <div className="bg-white rounded-2xl p-6 border border-gray-200">
          <p className="text-gray-700 leading-relaxed text-lg">
            Corenova Renewable is playing an active part in this shift by providing tailored wind energy solutions 
            that address the increasing need in Bhubaneswar. Combining cutting-edge technology and localized 
            knowledge, we assist companies and organizations in Odisha in transitioning towards cleaner 
            means of powering their activities.
          </p>
        </div>
      </div>
      
      <div className="relative">
        <div className="relative rounded-2xl overflow-hidden shadow-xl">
          <img 
            src="/images/wind.png" 
            alt="Wind Energy Solution in Odisha - Corenova Renewable Energy" 
            className="w-full h-96 object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
        </div>
      </div>
    </div>

    {/* CTA Section */}
    <div className="text-center mt-16">
      <div className="bg-gradient-to-r from-secondary-blue to-secondary-blue-dark rounded-2xl p-8 text-white">
        <h3 className="text-2xl font-bold mb-4">Start Your Wind Energy Journey</h3>
        <p className="mb-6 opacity-90">
          Discover how wind energy can transform your business operations in Odisha
        </p>
        <a 
          href="/contact" 
          className="btn bg-white text-secondary-blue hover:bg-gray-100 px-8 py-3 font-semibold inline-flex items-center justify-center gap-2"
        >
          Get Wind Energy Consultation
          <FontAwesomeIcon icon={faArrowRight} />
        </a>
      </div>
    </div>
  </div>
</section>

      <section className="section bg-white">
        <div className="container max-w-6xl">
          <div className="grid md:grid-cols-2 gap-12">
            <div>
              <h2 className="text-3xl lg:text-4xl font-bold text-dark mb-4">What We Offer</h2>
              <ul className="space-y-3">
                {[
                  'Onshore and offshore wind projects',
                  'Small and utility-scale turbines',
                  'Wind resource assessment',
                  'Grid integration and SCADA',
                  'Performance monitoring & maintenance',
                ].map((feature, i) => (
                  <li key={i} className="flex items-center gap-3"><FontAwesomeIcon className="text-primary-green" icon={faCheckCircle} /> <span>{feature}</span></li>
                ))}
              </ul>
            </div>
            <div className="space-y-3">
              <h3 className="text-2xl font-bold text-dark">Benefits</h3>
              {[
                '24/7 generation potential',
                'Scalable and cost-effective',
                'Long operational life',
                'Predictable energy costs',
              ].map((b, i) => (
                <div key={i} className="flex items-center gap-3"><FontAwesomeIcon icon={faLeaf} className="text-primary-green" /><span>{b}</span></div>
              ))}
            </div>
          </div>

          <div className="bg-gray-light p-6 rounded-2xl mt-12">
            <h3 className="text-2xl font-bold text-dark mb-3">Get Started</h3>
            <p className="text-gray mb-4">Schedule a wind feasibility study with our experts.</p>
            <a href="/contact" className="btn bg-primary-green text-white inline-flex items-center gap-2">
              Talk to an expert <FontAwesomeIcon icon={faArrowRight} />
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WindEnergy; 